import { motion } from "framer-motion";

const ORANGE = "#E8470A";

export function DestinationIntro({ destination, introImage, paragraphs }) {
  return (
    <section id="destino" style={{ backgroundColor: "#F5F2EC", padding: "96px 0" }}>
      <div style={{ maxWidth: "1140px", margin: "0 auto", padding: "0 24px" }}>
        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
          gap: "64px",
          alignItems: "center",
        }}>

          {/* Text */}
          <motion.div
            initial={{ opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.65, ease: "easeOut" }}
            viewport={{ once: true, margin: "-80px" }}
          >
            <span style={{
              display: "block",
              color: ORANGE,
              fontSize: "11px",
              fontWeight: 700,
              letterSpacing: "0.28em",
              textTransform: "uppercase",
              marginBottom: "16px",
            }}>
              Conocé el destino
            </span>
            <h2 style={{
              fontSize: "clamp(26px, 3vw, 36px)",
              fontWeight: 800,
              color: "#111827",
              lineHeight: 1.2,
              margin: "0 0 24px",
            }}>
              Todo lo que necesitás saber sobre {destination}
            </h2>
            <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
              {paragraphs.map((p, i) => (
                <p key={i} style={{
                  fontSize: "15px",
                  lineHeight: 1.75,
                  color: "#4B5563",
                  margin: 0,
                }}>
                  {p}
                </p>
              ))}
            </div>
          </motion.div>

          {/* Image */}
          {introImage && (
            <motion.div
              initial={{ opacity: 0, scale: 0.97 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.7, ease: "easeOut" }}
              viewport={{ once: true, margin: "-80px" }}
              style={{
                position: "relative",
                height: "460px",
                borderRadius: "20px",
                overflow: "hidden",
                boxShadow: "0 24px 60px rgba(0,0,0,0.16)",
              }}
            >
              <img
                src={introImage}
                alt={`Vista de ${destination}`}
                style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
              />
              <div style={{
                position: "absolute",
                inset: 0,
                background: "linear-gradient(to top, rgba(0,0,0,0.2), transparent)",
              }} />
            </motion.div>
          )}

        </div>
      </div>
    </section>
  );
}
